import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { useField } from "formik";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactTooltip from "react-tooltip";
import styles from "./CsplRadioButton.module.css";



const rdioBtn = makeStyles(() => ({
  root: {
    "& .MuiRadio-root": {
      paddingRight: "4px",
      paddingLeft:"0px",
      marginLeft: "10px",
      backgroundColor: "transparent",
    },
    '& .MuiSvgIcon-root':{
      width:"16px",
      height:"17px",
    }
  },
}));

function CsplRadioButtonField(props) {
  const { errorText, ...rest } = props;
  const [field, meta, helper] = useField(props);
  const { t } = useTranslation("common");
  const { setValue } = helper;
  const classes = rdioBtn();
  const [controlValue, setControlValue] = useState(null);
  function handleChange(event) {
    event.preventDefault();
    setValue(event.target.value);
  }

  useEffect(() => {

    let timer = setTimeout(() => {
      if(field.value){      
        setControlValue(field.value);
      }else if(props.defaultValue){
        setControlValue(props.defaultValue);
        setValue(props.defaultValue);
        if (props.defaultvaluedependencyhandler && typeof (props.defaultvaluedependencyhandler) === "function") {
              props.defaultvaluedependencyhandler(props.defaultValue);
        }
      }
    }, 1);

    return () => clearTimeout(timer);

    
  }, [field.value]);

  /* Position & clickable for moblie View */

  let place;
  let clickable;

  if (window.innerWidth < 575) {
    /* Mobile vIew */
    place = props.tooltipplace;
    clickable=true;
  } else {
    /* Large Mobiles,Tabs,Pc,Desktops */
    place = "right";
    clickable=false;    
  }

  
  return (
    <React.Fragment>
      <FormControl id="cspl-radio">
        <FormLabel id="demo-radio-buttons-group-label" focused={false} className={styles.radioButton_label}>
          {t(props.label)}
         {props.tooltip && props.tooltip !== "" && <span className="info mx-2 icon-hide"  data-tip
                data-for={props.tooltip}></span> }
          <ReactTooltip id={props.tooltip} place={place} effect="solid" className="pepToolTip" clickable={clickable}>
                   <span>{t(props.tooltip)}</span> 
          </ReactTooltip>


           
        </FormLabel>
        <RadioGroup
          row={props.rowdisplay}
          aria-labelledby="demo-radio-buttons-group-label"
          onChange={handleChange}
          {...field}
          {...rest}
          defaultValue={props.defaultValue}
          value={controlValue}
          className={classes.root}
        >
          {props.valuelist.map((value, index) => {
            return (
              <FormControlLabel
                key={index}
                value={value}
                disabled={props.disabled}
                control={<Radio />}
                label={value}
              />
            );
          })}
        </RadioGroup>
      </FormControl>
    </React.Fragment>
  );
}

export default CsplRadioButtonField;
